/* Directory disclosure is progressive enhancement; links and summaries work without JS. */
(() => {
  const desktop = window.matchMedia('(min-width: 768px)');
  const initialise = (root = document) => {
    root.querySelectorAll('[data-navera-directory]').forEach((group) => {
      if (!group.dataset.naveraDirectoryReady) {
        group.open = desktop.matches;
        group.dataset.naveraDirectoryReady = 'true';
      }
    });
  };
  const openHash = () => {
    let id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
    if (!id) return;
    const target = document.getElementById(id);
    if (target?.matches('[data-navera-directory], .navera-collection-details')) target.open = true;
  };
  initialise();
  openHash();
  window.addEventListener('hashchange', openHash);
  desktop.addEventListener('change', () => {
    document.querySelectorAll('[data-navera-directory]').forEach((group) => { group.open = desktop.matches; });
    openHash();
  });
  document.addEventListener('shopify:section:load', (event) => { initialise(event.target); openHash(); });
})();
